export const ROW_COUNT_OPTIONS = [10, 50, 100];
export const ROW_DEFAULT_COUNT = 10;
